import { Buttons } from '../../../controls/buttons';
import { Component, inject, model, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalDialogComponent } from 'src/app/controls/components/advanced/modal-dialog/modal-dialog.component';

@Component({
  selector: 'app-partner-onboarding-send-invitation-dialog',
  standalone: true,
  imports: [Buttons, ModalDialogComponent],
  templateUrl: './partner-onboarding-send-invitation-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './partner-onboarding-send-invitation-dialog.component.scss'
})
export class PartnerOnboardingSendInvitationDialogComponent {

  hasEditMailTemplatePermission = model<boolean>(false);

  private dialog = inject(NgbActiveModal);

  send() {
    this.dialog.close(PartnerOnboardingSendInvitationDialogResult.Send);
  }
  goToMailTemplate(event: Event){
    event.preventDefault();
    this.dialog.close(PartnerOnboardingSendInvitationDialogResult.GoToMailTemplate);
  }

  cancel() {
    console.log('cancel');
    this.dialog.dismiss();
  }
}

export enum PartnerOnboardingSendInvitationDialogResult {
  Send,
  Cancel,
  GoToMailTemplate
}
